<template>
  <div class="col-md-12 text-right mb-2">
    <small v-for="(err, i) in serverErrors" v-show="serverErrors.length > 0" :key="i" class="text-danger d-block">
      {{ err }}
    </small>
  </div>
</template>

<script>
export default {
  props: {
    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
